var map = {
	"./MasterCard.svg": 2198,
	"./Mir.svg": 4462,
	"./Visa.svg": 7778,
	"./arrow_bottom.svg": 15,
	"./arrow_left.svg": 8743,
	"./arrow_right.svg": 5076,
	"./arrow_top.svg": 9986,
	"./banner_calendar.svg": 9823,
	"./banner_calendar_green.svg": 8746,
	"./banner_chat.svg": 9690,
	"./banner_chat_green.svg": 9290,
	"./banner_telegram.svg": 8733,
	"./banner_window.svg": 9443,
	"./chart_hi.svg": 1401,
	"./chart_low.svg": 5849,
	"./chart_normal.svg": 5293,
	"./check_circle.svg": 5395,
	"./circle.svg": 838,
	"./close.svg": 2591,
	"./completed.svg": 5735,
	"./current.svg": 2748,
	"./done_small.svg": 1052,
	"./equipment.svg": 8080,
	"./goal.svg": 8343,
	"./just_arrow_right.svg": 2035,
	"./like.svg": 3747,
	"./logout.svg": 9999,
	"./men.svg": 6914,
	"./pay_default.svg": 1610,
	"./plan.svg": 608,
	"./play.svg": 8592,
	"./preloader_icon.svg": 1827,
	"./preloader_logo.svg": 4245,
	"./pro.svg": 9177,
	"./profile.svg": 6913,
	"./success-fill.svg": 5401,
	"./success.svg": 7111,
	"./telegram-black.svg": 4003,
	"./woman.svg": 8988,
	"./workout.svg": 6173,
	"./workout_refresh.svg": 5478,
	"./workout_run.svg": 4978
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2107;